import { Typography } from '@material-ui/core';
import { Priority } from '../../../models/communication.types';
import PriorityHighIcon from '../PriorityHighIcon.component';
import PriorityMediumIcon from '../PriorityMediumIcon.component';
import { useStyles } from './PriorityBox.styles';

interface PriorityBoxProps {
  priority: Priority;
  allreadySent?: boolean;
}

const PriorityBox: React.FC<PriorityBoxProps> = ({ priority, allreadySent }) => {
  const classes = useStyles();
  if (priority === Priority.Low) {
    return <></>;
  }
  const isMedium = priority === Priority.Medium;

  return (
    <div className={classes.priorityBox}>
      <div className={[classes.bar, isMedium ? classes.mediumPriority : classes.highPriority].join(' ')}>
        {isMedium ? <PriorityMediumIcon /> : <PriorityHighIcon color={'white'} />}
        <Typography>
          {`Ta wiadomość ${allreadySent ? 'została' : 'zostanie'} wysłana ${
            isMedium ? 'jako ważna' : 'z wysokim priorytetem'
          }.`}
        </Typography>
      </div>
    </div>
  );
};

export default PriorityBox;
